import { Options } from '@sheerid/jslib';
import { RecursivePartial } from './lib/types/types';

export const programId = '607df845b341731281e9bd40';

export const defaultOptions: RecursivePartial<Options> = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },
    logLevel: 'error',
    useFingerprinting: true,
    urlStudentFaq: 'https://shop.adidas.jp/studentdiscount/#faq',
};
